"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWrappedStdTx = void 0;
const amino_1 = require("@cosmjs/amino");
function isWrappedStdTx(wrapped) {
    return wrapped.type === "cosmos-sdk/StdTx" && (0, amino_1.isStdTx)(wrapped.value);
}
exports.isWrappedStdTx = isWrappedStdTx;
//# sourceMappingURL=tx.js.map